import { ITooltipHostStyles } from '@fluentui/react';

export const TooltipHostStyles: Partial<ITooltipHostStyles> = { root: { display: 'inline-block' } };

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

export const CustomLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-bottom: -20px;
`;

export const CustomRequiredLabel = styled.div`
  display: flex;
  color: #a4262c;
  padding-left: 3px;
`;

export const CustomTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
`;

export const LabelLoadingContainer = styled.div`
  display: flex;
  height: 24px;
  align-content: center;
  justify-content: center;
  padding-left: 4px;
`;

export const SelectExistingLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-bottom: -10px;
`;
